<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">
              <strong>Verval</strong> Daftar Riwayat Hidup (CV)
              {{ jenis === 'kasek' ? 'Kepala Sekolah' : 'Fasilitator' }}</h1
            >
            <div>
              Modul ini digunakan untuk melakukan Verval Ajuan Daftar Riwayat Hidup (CV) Peserta Sekolah Penggerak
            </div>
            <template v-if="$allow(`psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.kinerja`)">
              <v-divider class="my-3" />
              <div class="text-md-right">
                <v-btn dark color="pink" @click="onKinerja">
                  <v-icon left>mdi-text-box-check</v-icon>
                  Laporan Kinerja
                </v-btn>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik :value="statistik"></statistik>
    <!--daftar-->
    <v-card flat>
      <v-card-text>
        <base-table-header
          btn-filter
          btn-download
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:toolbar>
            <v-select
              class="mt-7"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="fetchData"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Kandididat yang perlu di periksa</div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-filter
          ref="filter"
          title="Pilih Filter Status"
          :filtered="filtered"
          :filters="formFilter"
          :paramsFilter="filters"
          @save="filterSave"
        />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0" @click="onVerval(item)">
                        <v-list-item-icon class="mr-1 my-auto">
                          <v-icon color="secondary" size="60">mdi-account-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption grey--text">
                            Nama Kandidat
                          </p>
                          <span class="body-1">
                            <strong>
                              {{ $getDeepObj(item, 'ptk.data.nama') || '-' }}
                            </strong>
                          </span>
                          <template v-if="jenis === 'instruktur'">
                            <template v-if="Number(item && item.is_cadangan) > -1">
                              <span class="caption grey--text">Status Cadangan: </span>
                              <span class="warning--text">{{
                                Number(item && item.is_cadangan) === 1
                                  ? 'Akselerasi 1'
                                  : Number(item && item.is_cadangan) === 2
                                  ? 'Akselerasi 2'
                                  : Number(item && item.is_cadangan) === 3
                                  ? 'Akselerasi 3'
                                  : 'Reguler'
                              }}</span>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="Number(item && item.is_cadangan) > -1">
                              <span class="caption grey--text">Status Cadangan: </span>
                              <span class="warning--text">{{
                                Number(item && item.is_cadangan) >= 1 ? 'Cadangan' : 'Reguler'
                              }}</span>
                            </template>
                          </template>
                          <template v-if="$isObject(lockedAkun(item))">
                            <span class="caption grey--text">Verifikator: </span>
                            <span class="warning--text">{{ $getDeepObj(lockedAkun(item), 'data.nama') || '-' }}</span>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nomor HP </small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <template>
                              {{ $getDeepObj(item, 'no_wa') || $getDeepObj(item, 'ptk.data.no_hp') || '-' }}
                              <v-icon
                                v-if="$getDeepObj(item, 'no_wa')"
                                color="success"
                                small
                                dark
                                @click="onCall(item)"
                              >
                                mdi-whatsapp
                              </v-icon>
                            </template>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Waktu Pengajuan</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            {{ $localDate((detailAjuan(item) && detailAjuan(item).wkt_proses) || '') || '-' }}
                            <p class="red--text" v-if="Number($getDeepObj(item, 'is_autosubmit')) === 1">
                              (autosubmit)
                            </p>
                            <p class="success--text" v-if="isAjuanRevisi(item)">
                              (ajuan revisi)
                            </p>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Status</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip :color="getColor(item.k_verval_psp)" dark small>
                              {{ $getDeepObj(item, 'm_verval_psp.data.keterangan') || '-' }}
                            </v-chip>
                            <span
                              style="cursor: pointer"
                              v-if="Number(item.k_verval_psp) === 1"
                              class="group pa-2"
                              @click="
                                $info('Data sedang dalam proses perbaikan oleh pendaftar', {
                                  tipe: 'warning',
                                  data: '',
                                })
                              "
                            >
                              <v-icon dark color="warning" medium>mdi-pencil-circle</v-icon>
                            </span>
                            <template v-if="Number(item.is_aktif) === 0 && jenis === 'kasek'">
                              <div class="mt-1"></div>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-chip small v-bind="attrs" v-on="on" :class="['red white--text']">
                                    Non-Aktif
                                  </v-chip>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi Selanjutnya</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn
                              color="primary"
                              small
                              block
                              @click="onKunci(item)"
                              v-if="
                                $allow(
                                  `psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.kunci`,
                                  item.policies
                                )
                              "
                            >
                              KUNCI BERKAS
                            </v-btn>
                            <v-btn
                              v-else-if="isAllowAkses(item.policies)"
                              color="primary"
                              small
                              block
                              @click="onVerval(item)"
                            >
                              {{ isAllowAkses(item.policies) ? 'PERIKSA' : 'LIHAT DETIL' }}
                            </v-btn>
                            <v-btn v-else color="primary" small block @click="onVerval(item)">
                              LIHAT DETAIL
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions[jenis]" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>

    <base-modal-full
      ref="modal"
      :title="formulir['title']"
      :autoClose="formulir['autoClose']"
      :useSave="formulir['is_edit']"
      @close="onClose"
      @save="onSave"
    >
      <form-berkas
        ref="formulir"
        :masters="Object.assign({}, masters, { alasan_verval: formulir['alasan_verval'] || {} })"
        :id="formulir['id']"
        :detail="formulir['detail']"
        :berkas="formulir['berkas']"
        :fungsi="formulir['fungsi']"
        :angkatan="Number(params.angkatan) > 1 ? 2 : 1"
        :statistik="formulir['statistik']"
        :isEdit="formulir['is_edit']"
        :isDisable="formulir['is_disable']"
        :initValue="formulir['init']"
        :jenis="jenis"
      ></form-berkas>
    </base-modal-full>
    <base-modal-full ref="kinerja" title="Laporan Kinerja" :useSave="false">
      <form-kinerja
        ref="formkinerja"
        title="Verval Daftar Riwayat Hidup (CV)"
        :akun="akun"
        :jenis="jenis"
        :angkatan="params.gelombang"
        :useDownload="$allow(`psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.kinerja-download`)"
        @download="onUnduhKinerja"
      ></form-kinerja>
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import Statistik from '../component/Statistik';
import actions from './actions';
import FormBerkas from '../formulir/Berkas';
import FormKinerja from '../component/Kinerja';
export default {
  name: 'Index',
  components: { FormBerkas, Statistik, FormKinerja },
  mixins: [list],
  data() {
    return {
      actions: actions,
      jenis: '',
      formulir: {},
      listTimVerval: [],
      listLaporan: [
        {
          key: 'download',
          label: `Daftar Laporan Verval CV`,
          acl: this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.download`),
        },
        {
          key: 'download-nilai',
          label: `Daftar Laporan Nilai CV`,
          acl: this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.download-nilai`),
        },
        {
          key: 'download-nilai-tbs',
          label: `Daftar Laporan Nilai TBS`,
          acl: this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.download-nilai-tbs`),
        },
        {
          key: 'download-nilai-tahap1',
          label: `Daftar Laporan Nilai Tahap 1`,
          acl: this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.download-nilai-tahap1`),
        },
        {
          key: 'download-organisasi',
          label: `Daftar CV Organisasi`,
          acl: this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.download-organisasi`),
        },
      ],
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => (state.data && state.data.akun) || {},
      pspConfig: (state) => (state.data && state.data.config) || {},
    }),

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    mapTimVerval() {
      let temp = {};
      for (const akun of this.listTimVerval) {
        temp[this.$getDeepObj(akun, 'akun.data.akun_id')] = this.$getDeepObj(akun, 'akun.data.nama');
      }
      return temp;
    },

    mCadangan() {
      return {
        instruktur: {
          '0': 'Reguler',
          '1': 'Akselerasi 1',
          '2': 'Akselerasi 2',
          '3': 'Akselerasi 3',
        },
        kasek: {
          '0': 'Reguler',
          '1': 'Cadangan',
        },
      };
    },

    mStatusTua() {
      return {
        '0': 'Usia < 57',
        '1': 'Usia >= 57',
      };
    },

    mSasaranPop() {
      return {
        '0': 'Bukan Sasaran POP',
        '1': 'Sasaran POP',
      };
    },

    formFilter() {
      let master = Object.assign({}, this.masters.verval_psp);
      // delete kandidat
      delete master[1];
      let temp = [
        {
          label: 'Pilih Verifikator',
          model: 'akun_id',
          type: 'select',
          props: ['attach'],
          master: this.$mapForMaster(this.mapTimVerval),
          labelColor: 'secondary',
          grid: { cols: 12 },
        },
        {
          label: 'Pilih Status Verval',
          default: true,
          type: 'checkbox',
          model: 'k_verval_psp',
          master: this.$mapForMaster(master),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: this.jenis === 'instruktur' ? 12 : 6 },
        },
      ];

      if (this.jenis === 'instruktur') {
        const mUnsur = Object.assign({}, this.masters.unsur_psp);
        let filterUnsur = {};
        Object.keys(mUnsur).forEach((key) => {
          if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 21, 22, 23, 25, 26, 27, 28].includes(Number(key))) {
            this.$set(filterUnsur, key, mUnsur[key]);
          }
        });

        temp.splice(2, 0, {
          label: 'Pilih Unsur',
          default: true,
          type: 'checkbox',
          model: 'k_unsur_psp',
          master: this.$mapForMaster(filterUnsur),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: 6 },
        });
      } else {
        temp.push({
          label: 'Status POP',
          model: 'is_sasaran_pop',
          type: 'select',
          props: ['attach'],
          master: [
            { text: 'Sasaran POP', value: '1' },
            { text: 'Bukan Sasaran POP', value: '0' },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });
      }

      let mCadangan = [];
      if (this.jenis === 'instruktur') {
        mCadangan = [
          { text: 'Semua', value: 0 },
          { text: 'Reguler', value: '0' },
          { text: 'Akselerasi 1', value: '1' },
          { text: 'Akselerasi 2', value: '2' },
          { text: 'Akselerasi 3', value: '3' },
        ];
      } else {
        mCadangan = [
          { text: 'Semua', value: 0 },
          { text: 'Reguler', value: '0' },
          { text: 'Cadangan', value: '1' },
        ];
      }

      temp.push({
        label: 'Status Cadangan',
        model: 'is_cadangan',
        type: 'select',
        props: ['attach'],
        master: mCadangan,
        labelColor: 'secondary',
        grid: { cols: 12, md: 6 },
      });

      if (this.jenis === 'kasek') {
        temp.push({
          label: 'Usia',
          model: 'is_tua',
          type: 'select',
          props: ['attach'],
          master: [
            { text: '< 56', value: '0' },
            { text: '>= 56', value: '1' },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });
        temp.push({
          label: 'Jenjang',
          model: 'k_jenjang',
          default: true,
          type: 'select',
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          master: this.$mapForMaster(this.masters.jenjang || {}).filter((s) =>
            [1, 2, 3, 4, 5].includes(Number(s.value))
          ),
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });
      }

      return temp;
    },

    filtersMaster() {
      return {
        k_verval_psp: this.masters && this.masters['verval_psp'],
        k_propinsi: this.masters && this.masters['propinsi'],
        k_kota: this.masters && this.masters['kota'],
        k_unsur_psp: this.masters && this.masters['unsur_psp'],
        k_jenjang: this.masters && this.masters['jenjang'],
        akun_id: this.mapTimVerval,
        is_cadangan: this.mCadangan[this.jenis] || this.mCadangan.kasek,
        is_tua: this.mStatusTua,
        is_sasaran_pop: this.mSasaranPop,
      };
    },

    mGelombang() {
      const jenis = this.jenis === 'kasek' ? 'peserta' : 'pelatih_ahli';
      const result = [];

      for (let i = Number(this.pspConfig[jenis]['gelombang']); i > 0; i--) {
        result.push({ text: `Angkatan ${i}`, value: i });
      }

      return result;
    },
  },
  created() {
    this.jenis = this.$route.meta.jenis || 'kasek';
    this.getMasters('verval_psp;propinsi;kota;unsur_psp;jenjang');
    this.getTimVerval({ jenis: this.jenis }).then(({ data }) => {
      this.listTimVerval = data;
    });
  },
  mounted() {
    const jenis = this.$route.meta.jenis === 'kasek' ? 'peserta' : 'pelatih_ahli';
    this.$set(this.params, 'gelombang', this.$getDeepObj(this, `pspConfig.${jenis}.gelombang`));
  },
  methods: {
    ...mapActions('verval', ['fetch', 'getDetail', 'action', 'downloadList', 'getKinerja', 'getTimVerval']),
    ...mapActions('master', ['getMasters']),

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        this.fetch({ params, jenis: this.jenis }).then(({ data, meta }) => {
          this.data = data || [];
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          resolve(true);
        });
      });
    },

    onClose() {
      if (!this.formulir['autoClose']) {
        const msg = [
          '<h3>Apakah Anda yakin ingin keluar dari halaman Verifikasi Berkas Peserta ?</h3>',
          'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
        ].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      }
    },

    lockedAkun(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const akun = this.$getDeepObj(proses.filter((item) => item.k_profil_proses_psp === 7)[0], 'akun');
      return akun || {};
    },

    isAjuanRevisi(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const isRevisi = proses.findIndex((s) => Number(s.k_profil_proses_psp) === 8) > -1;
      const isAjuan = [2, 3].indexOf(Number(item.k_verval_psp)) > -1;
      return isAjuan && isRevisi;
    },

    detailAjuan(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const ajuan = proses.filter((item) => item.k_profil_proses_psp === 6)[0];
      return ajuan;
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(this.$getDeepObj(item, 'no_wa'))}`;
      window.open(url, '_blank');
    },

    isAllowAkses(policies) {
      let enable = false;
      let akses = [
        `psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.setuju`,
        `psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.tolak`,
        `psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas.tolak-revisi`,
      ];

      akses.forEach((key) => {
        if (this.$allow(key, policies)) {
          enable = true;
          return;
        }
      });

      return enable;
    },

    async onVerval(item) {
      const kVerval = Number(item.k_verval_psp);
      const status = {
        color: this.getColor(kVerval),
        keterangan: this.$getDeepObj(item, 'm_verval_psp.data.keterangan') || '-',
      };

      let init = {};
      let statistik = this.statistik;

      init = {
        pilihan: kVerval === 3 ? null : kVerval === 4 ? 1 : kVerval === 6 ? 2 : 3,
      };

      this.$set(this.formulir, 'form', 'form-berkas');
      this.$set(this.formulir, 'title', 'Pemeriksaan Daftar Riwayat Hidup (CV)');
      this.$set(this.formulir, 'id', item.psp_profil_id);
      this.$set(this.formulir, 'statistik', statistik);
      this.$set(this.formulir, 'init', null);

      this.getDetail({ id: item.psp_profil_id, jenis: this.jenis }).then(({ data }) => {
        const prosesAjuan = this.$getDeepObj(data, 'psp_profil_proseses.data').filter(
          (item) => item.k_profil_proses_psp === 8
        )[0];

        this.$set(this.formulir, 'alasan_verval', this.$getDeepObj(data, 'meta.alasan-verval'));
        this.$set(this.formulir, 'is_disable', !this.isAllowAkses(data.policies));
        this.$set(this.formulir, 'is_edit', this.isAllowAkses(data.policies));
        this.$set(this.formulir, 'autoClose', !this.isAllowAkses(data.policies));

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'init', init);
          this.$set(this.formulir, 'detail', data);
          this.$set(this.formulir, 'berkas', this.$getDeepObj(data, 'psp_profil_berkases.data'));
          this.$set(this.formulir.detail, 'status', status);
          this.$set(this.formulir.detail, 'alasan', (prosesAjuan && prosesAjuan.catatan) || '');
          this.$set(this.formulir.detail, 'verifikator', this.lockedAkun(item));
        });
      });
    },

    onSave() {
      const formulir = Object.assign({}, this.$refs.formulir.getValue());
      const status = formulir.pilihan;
      const alasan = formulir.alasan;
      const id = formulir.id;
      if (status) {
        const aksi = status === 1 ? 'tolak' : status === 2 ? 'setuju' : 'tolak-revisi';
        const html = `<span class="subtitle-1">Anda Yakin ingin <strong>${
          status === 1 ? 'menolak' : status === 2 ? 'menerima' : 'menyatakan perbaikan'
        }</strong> ajuan verval berikut ?</span>`;

        this.$confirm(html, 'Konfirmasi', { tipe: status === 1 ? 'error' : status === 2 ? 'success' : 'warning' }).then(
          () => {
            this.$refs.modal.loading = true;
            this.action({ id: id, type: aksi, jenis: this.jenis, params: { alasan: JSON.stringify(alasan) } })
              .then(() => {
                this.$success('Data ajuan berhasil di ubah');
                this.$refs.modal.dialog = false;
                this.onReload();
              })
              .catch(() => {
                this.$refs.modal.loading = false;
              });
          }
        );
        this.$refs.modal.loading = false;
      } else {
        this.$error('Silakan tentukan hasil verifikasi data sebelum simpan');
        this.$refs.modal.loading = false;
      }
    },

    onKunci(data) {
      this.id = data.psp_profil_id;
      this.$confirm(`Anda yakin ingin mengunci Ajuan di atas agar bisa diverifikasi?`, `Kunci Ajuan`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.id, jenis: this.jenis, type: 'kunci' }).then(() => {
          this.$success(`Ajuan Peserta berhasil dikunci`);
          this.onReload();
        });
      });
    },

    onBatalKunci(data) {
      this.$confirm(`Anda yakin ingin membatalkan Kunci Verifikasi Ajuan Peserta di atas?`, `Batal Kunci Ajuan`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_profil_id, jenis: this.jenis, type: 'batal-kunci' }).then(() => {
          this.$success(`Batal kunci Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    onBatalVerval(data) {
      this.$confirm(`Anda yakin ingin membatalkan VerVal Ajuan di atas?`, `Batal Verval`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_profil_id, jenis: this.jenis, type: 'batal-verval' }).then(() => {
          this.$success(`Batal Verval Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 60,
          iconColor: 'secondary',
          title: this.$getDeepObj(data, 'ptk.data.nama') || '',
          subtitles: [`<span class="text--primary">${this.$getDeepObj(data, 'ptk.data.no_ukg')}</span>`],
        },
      ];
    },

    async onKinerja() {
      const params = {
        gelombang: this.params.gelombang,
        count: 100,
        jenis: this.jenis,
      };

      const resp = await this.getKinerja({ params });
      const nilais = (resp && resp.data) || [];
      const statistik = this.statistik || {};
      const limit = Number(this.$getDeepObj(resp, 'meta.total')) || 0;

      const items = nilais.map((key, index) => {
        return {
          no: index + 1,
          nama: key.nama,
          diproses: key.diproses,
          disetujui: key.disetujui,
          revisi: key.revisi,
          ditolak: key.ditolak,
          jumlah: Number(key.diproses) + Number(key.disetujui) + Number(key.revisi) + Number(key.ditolak),
        };
      });

      const headers = [
        {
          text: 'NO',
          align: 'start',
          sortable: false,
          value: 'no',
        },
        { text: 'Tim Verval', value: 'nama' },
        { text: 'Diproses', value: 'diproses' },
        { text: 'Disetujui', value: 'disetujui' },
        { text: 'Revisi', value: 'revisi' },
        { text: 'Ditolak', value: 'ditolak' },
        { text: 'Jumlah', value: 'jumlah' },
      ];

      this.$refs.kinerja.open();

      this.$nextTick(() => {
        this.$refs.formkinerja.reset();
        this.$refs.formkinerja.headers = headers;
        this.$refs.formkinerja.data = (resp && resp.nilais) || [];
        this.$refs.formkinerja.items = items || [];
        this.$refs.formkinerja.kinerja = (resp && resp.kinerja) || null;
        this.$refs.formkinerja.statistik = statistik;
        this.$refs.formkinerja.limit = limit;
      });
    },

    onUnduhKinerja() {
      const params = {
        jenis: this.jenis,
      };
      this.unduhKinerja(params).then((url) => {
        window.open(url, '_blank');
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
